export default {
  main: {
    hero: `
        Unsere Spiele<br>
        sind <strong>lebendige</strong> Welten<br>
        mit <strong>charmanten</strong><br>
        Charakteren
      `,
    homescapes: `Ein epischer Teil der Scapes™-Reihe, in dem die Spieler zusammen mit Austin dem Butler ein wunderschönes Herrenhaus restaurieren können`,
    township: `Ein unterhaltsames Stadtaufbauspiel, vollgepackt mit Events, Wettbewerben und PvP-Turnieren`,
  },
  common: {
    login: 'Anmelden',
    logout: 'Abmelden',
    support: 'Kundendienst',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    and: 'und',
    guest: 'Gast',
    play: 'Spielen',
    install: 'Installieren',
  },
  support: {
    title: 'Brauchst du Hilfe?',
    description: `Wenn du beim Spielen dieses Spiels auf irgendwelche Probleme stößt,
      helfen wir dir gerne weiter und beantworten all deine Fragen.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Hilf Austin dem Butler dabei, Wärme und Komfort zurück in die wunderbare Villa seiner Familie zu bringen.',
    description: `Hilf Austin dem Butler dabei, Wärme und Komfort zurück
      in die wunderbare Villa seiner Familie zu bringen. Komm nur herein – Abenteuer
      erwarten dich bereits auf der Türschwelle!`,
    xsolla: 'Xsolla ist ein authorisierter weltweiter Vertriebspartner von Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes auf deinem Desktop!
      Installiere die Web-Version des Spiels und besuche Austin mit nur wenigen Klicks!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: 'Baue die Stadt deiner Träume!',
    description: `Baue die Stadt deiner Träume!
      Fahre die Ernte ein, verarbeite sie in deinen Fabriken weiter
      und verkaufe Güter,um deine Stadt wachsen zu lassen.`,
    xsolla: 'Xsolla ist ein authorisierter weltweiter Vertriebspartner von Township',
    install: {
      title: '@:common.install',
      text: `Township auf Ihrem Desktop!
      Installieren Sie die Webversion des Spiels und besuchen Sie Ihre Stadt mit nur ein paar Klicks!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message:
      'Diese Webseite verwendet Cookies, um dir das bestmögliche Nutzererlebnis auf unserer Webseite bieten zu können.',
    link: 'Weitere Infos',
    button: 'Annehmen',
  },
  game: {
    notSupported: `Mobilgeräte werden nicht unterstützt.
      Melde dich mit deinem Computer an, um zu spielen.`,
  },
};
